module.exports = __webpack_public_path__ + "static/media/image7.7231cef7.jpg";